import styled from 'styled-components'

export const StepCircleWrap = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`
